export default "__VITE_ASSET__BsHbg6_F__"